import FlipCountdown from 'component/FlipCountdown';

export default function MyCountDown({ remainTime }: { remainTime: number }) {
  return (
    <>
      <FlipCountdown remainTime={remainTime} />
    </>
  );
}
